$(function () {
    $(window).on('scroll', function () {
        if (!$('body').hasClass('home')) {
            return;
        }

        let scroll_amount = $(window).scrollTop();
        if (scroll_amount > 50) {
            $('.navbar').fadeIn('slow');
        } else {
            $('.navbar').fadeOut('slow');
        }
    });
});
